import { render, staticRenderFns } from "./Codex.vue?vue&type=template&id=a2029b26&scoped=true&"
import script from "./Codex.vue?vue&type=script&lang=js&"
export * from "./Codex.vue?vue&type=script&lang=js&"
import style0 from "./Codex.vue?vue&type=style&index=0&id=a2029b26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2029b26",
  null
  
)

export default component.exports